/* file description */
import { delModuleRecordList } from './assetModel';
import { message } from 'antd';
import { TIP_MSG_MAP } from '@/components/SPTableWithModel/effect/consts';

export const delAssetModuleByRequest = async (FetchAPI: any, params: any) => {
  try {
    const res = await delModuleRecordList(FetchAPI, params.namespaceID, params.moduleID, params.recordKey);
    if (res) {
      message.success(TIP_MSG_MAP.autoLineEditDeleteSuccess);
    }
    return res;
  } catch (e) {
    message.error(TIP_MSG_MAP.autoLineEditDeleteError);
    return {};
  }
};
